$(document).on("revelation__s27_bxh rendered", {}, function (event, uniqueId) {
  // var $this = $("#" + uniqueId);
  //console.log(uniqueId);
  // $("#tabs > .tab_head > ul > li").click(function (e) {
  //   $(this).addClass("active");
  //   $(this).siblings().removeClass("active");
  //   var index = $(this).index();
  //   $("#tabs > .tab_content > div").removeClass("active");
  //   $("#tabs > .tab_content > div:nth-child(" + (index + 1) + ")").addClass(
  //     "active"
  //   );
  // });
});
